




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import AdminChangelogInnerTableCell from '@/modules/changelog/components/admin/AdminChangelogInnerTableCell.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminChangelogInnerTableRow extends mixins<TesTableRow>(TesTableRow) {
  columnComponents = {
    old: {
      component: AdminChangelogInnerTableCell,
      handler: value => ({ changelog: value })
    },
    attributes: {
      component: AdminChangelogInnerTableCell,
      handler: value => ({ changelog: value })
    }
  }
}
